import Vue, { ComponentOptions } from 'vue'
import Chatx from './chatx.vue'
import ChatxMessage from './chatx-message/chatx-message.vue'

export default {
  components: {
    ChatxMessage,
  },
  exportComponents: {
    Chatx,
    ChatxMessage,
  },
} as ComponentOptions<Vue> & Export

type Export = { exportComponents?: any }
